// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3jIuN","clinicsSelect":"TableHeading_clinicsSelect__26giL"};